import * as tslib_1 from "tslib";
import { DateComponent, intersectRanges, addMs, memoizeRendering, Slicer } from '@fullcalendar/core';
import { normalizeRange, isValidDate } from './timeline-date-profile';
import TimelineLaneEventRenderer from './TimelineLaneEventRenderer';
import TimelineLaneFillRenderer from './TimelineLaneFillRenderer';
var TimelineLane = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineLane, _super);
    function TimelineLane(fgContainerEl, bgContainerEl, timeAxis) {
        var _this = _super.call(this, bgContainerEl) || this;
        _this.slicer = new TimelineLaneSlicer();
        _this.renderEventDrag = memoizeRendering(_this._renderEventDrag, _this._unrenderEventDrag);
        _this.renderEventResize = memoizeRendering(_this._renderEventResize, _this._unrenderEventResize);
        _this.fgContainerEl = fgContainerEl;
        _this.timeAxis = timeAxis;
        var fillRenderer = _this.fillRenderer = new TimelineLaneFillRenderer(bgContainerEl, timeAxis);
        var eventRenderer = _this.eventRenderer = new TimelineLaneEventRenderer(fgContainerEl, timeAxis);
        _this.mirrorRenderer = new TimelineLaneEventRenderer(fgContainerEl, timeAxis);
        _this.renderBusinessHours = memoizeRendering(fillRenderer.renderSegs.bind(fillRenderer, 'businessHours'), fillRenderer.unrender.bind(fillRenderer, 'businessHours'));
        _this.renderDateSelection = memoizeRendering(fillRenderer.renderSegs.bind(fillRenderer, 'highlight'), fillRenderer.unrender.bind(fillRenderer, 'highlight'));
        _this.renderBgEvents = memoizeRendering(fillRenderer.renderSegs.bind(fillRenderer, 'bgEvent'), fillRenderer.unrender.bind(fillRenderer, 'bgEvent'));
        _this.renderFgEvents = memoizeRendering(eventRenderer.renderSegs.bind(eventRenderer), eventRenderer.unrender.bind(eventRenderer));
        _this.renderEventSelection = memoizeRendering(eventRenderer.selectByInstanceId.bind(eventRenderer), eventRenderer.unselectByInstanceId.bind(eventRenderer), [_this.renderFgEvents]);
        return _this;
    }
    TimelineLane.prototype.render = function (props, context) {
        var timeAxis = this.timeAxis;
        var slicedProps = this.slicer.sliceProps(props, props.dateProfile, timeAxis.tDateProfile.isTimeScale ? null : props.nextDayThreshold, context.calendar, this, timeAxis);
        this.renderBusinessHours(context, slicedProps.businessHourSegs);
        this.renderDateSelection(context, slicedProps.dateSelectionSegs);
        this.renderBgEvents(context, slicedProps.bgEventSegs);
        this.renderFgEvents(context, slicedProps.fgEventSegs);
        this.renderEventSelection(slicedProps.eventSelection);
        this.renderEventDrag(slicedProps.eventDrag);
        this.renderEventResize(slicedProps.eventResize);
    };
    TimelineLane.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.renderBusinessHours.unrender();
        this.renderDateSelection.unrender();
        this.renderBgEvents.unrender();
        this.renderFgEvents.unrender();
        this.renderEventSelection.unrender();
        this.renderEventDrag.unrender();
        this.renderEventResize.unrender();
    };
    TimelineLane.prototype._renderEventDrag = function (state) {
        if (state) {
            this.eventRenderer.hideByHash(state.affectedInstances);
            this.mirrorRenderer.renderSegs(this.context, state.segs, { isDragging: true, sourceSeg: state.sourceSeg });
        }
    };
    TimelineLane.prototype._unrenderEventDrag = function (state) {
        if (state) {
            this.eventRenderer.showByHash(state.affectedInstances);
            this.mirrorRenderer.unrender(this.context, state.segs, { isDragging: true, sourceSeg: state.sourceSeg });
        }
    };
    TimelineLane.prototype._renderEventResize = function (state) {
        if (state) {
            // HACK. eventRenderer and fillRenderer both use these segs. would compete over seg.el
            var segsForHighlight = state.segs.map(function (seg) {
                return tslib_1.__assign({}, seg);
            });
            this.eventRenderer.hideByHash(state.affectedInstances);
            this.fillRenderer.renderSegs('highlight', this.context, segsForHighlight);
            this.mirrorRenderer.renderSegs(this.context, state.segs, { isDragging: true, sourceSeg: state.sourceSeg });
        }
    };
    TimelineLane.prototype._unrenderEventResize = function (state) {
        if (state) {
            this.eventRenderer.showByHash(state.affectedInstances);
            this.fillRenderer.unrender('highlight', this.context);
            this.mirrorRenderer.unrender(this.context, state.segs, { isDragging: true, sourceSeg: state.sourceSeg });
        }
    };
    TimelineLane.prototype.updateSize = function (isResize) {
        var _a = this, fillRenderer = _a.fillRenderer, eventRenderer = _a.eventRenderer, mirrorRenderer = _a.mirrorRenderer;
        fillRenderer.computeSizes(isResize);
        eventRenderer.computeSizes(isResize);
        mirrorRenderer.computeSizes(isResize);
        fillRenderer.assignSizes(isResize);
        eventRenderer.assignSizes(isResize);
        mirrorRenderer.assignSizes(isResize);
    };
    return TimelineLane;
}(DateComponent));
export default TimelineLane;
var TimelineLaneSlicer = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineLaneSlicer, _super);
    function TimelineLaneSlicer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimelineLaneSlicer.prototype.sliceRange = function (origRange, timeAxis) {
        var tDateProfile = timeAxis.tDateProfile;
        var _a = timeAxis.props, dateProfile = _a.dateProfile, dateProfileGenerator = _a.dateProfileGenerator;
        var dateEnv = timeAxis.context.dateEnv;
        var normalRange = normalizeRange(origRange, tDateProfile, dateEnv);
        var segs = [];
        // protect against when the span is entirely in an invalid date region
        if (timeAxis.computeDateSnapCoverage(normalRange.start) < timeAxis.computeDateSnapCoverage(normalRange.end)) {
            // intersect the footprint's range with the grid's range
            var slicedRange = intersectRanges(normalRange, tDateProfile.normalizedRange);
            if (slicedRange) {
                segs.push({
                    start: slicedRange.start,
                    end: slicedRange.end,
                    isStart: slicedRange.start.valueOf() === normalRange.start.valueOf() && isValidDate(slicedRange.start, tDateProfile, dateProfile, dateProfileGenerator),
                    isEnd: slicedRange.end.valueOf() === normalRange.end.valueOf() && isValidDate(addMs(slicedRange.end, -1), tDateProfile, dateProfile, dateProfileGenerator)
                });
            }
        }
        return segs;
    };
    return TimelineLaneSlicer;
}(Slicer));
